<template>
  <div>
    <el-main v-if="isPc">
      <el-tabs v-model="active" tab-position="left" @tab-click="tabClick">
        <el-tab-pane label="企業展示">
          <el-input
            placeholder="請輸入關鍵字"
            v-model="company_name"
            clearable
            @clear="getEnterprisesList(1)"
            autofocus="true"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getEnterprisesList(1)"
            ></el-button>
          </el-input>
          <el-form ref="form" label-width="80px">
            <el-form-item label="篩選：">
              <el-select v-model="region" placeholder="请选择地區">
                <el-option
                  v-for="item in companyAreaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option> </el-select
              >&nbsp;&nbsp;&nbsp;
              <el-select v-model="field" placeholder="请选择行業">
                <el-option
                  v-for="item in companyFieldList"
                  :key="item.industry_id"
                  :label="item.industry_name"
                  :value="item.industry_id"
                ></el-option> </el-select
              >&nbsp;&nbsp;&nbsp;
              <el-button type="primary" @click="clearSelect"
                >清除篩選</el-button
              >
            </el-form-item>
          </el-form>
          <el-row :gutter="24" class="company_list">
            <el-col
              :span="12"
              v-for="item in companyList"
              :key="item.company_id"
            >
              <div class="grid-content" @click="fnToCompany(item.company_id)">
                <el-image :src="$imgUrl + item.company_logo" fit="cover">
                  <div slot="error" class="image-slot">
                    <p class="bg-title" v-html="item.company_code[0]"></p>
                  </div>
                </el-image>
                <div class="company_title">
                  <h3 v-html="item.company_name"></h3>
                  <div class="company_info">
                    <div class="company_tel">
                      <em></em>
                      <span>{{ item.phone }}</span>
                    </div>
                    <div class="company_field">
                      <em></em>
                      <span>{{ item.industry_name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="currentPage"
            :page-size="pageSize"
            :page-count="totalPageNum"
            @current-change="handleCurrentChange"
            v-if="totalPageNum > 0"
          >
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="會員名錄" class="member_list">
          <el-input
            placeholder="請輸入關鍵字"
            v-model="member_name"
            clearable
            @clear="getAssociationMemberList(1)"
            autofocus="true"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getAssociationMemberList(1)"
            ></el-button>
          </el-input>
          <div class="file-type" v-if="areaList.length > 0">
            <h3>地区:</h3>
            <!-- <span :class="[{ active: ass_area_id == '' }, 'little_hand']" @click="changeArea(1, '')">全部</span> -->
            <span
              :class="[
                { active: ass_area_id == item.ass_area_id },
                'little_hand',
              ]"
              v-for="(item, index) in areaList"
              :key="index"
              @click="changeArea(1, item.ass_area_id)"
              >{{ item.area }}</span
            >
          </div>
          <div style="clear: both"></div>

          <el-row :gutter="20">
            <el-col
              :span="4"
              v-for="item in memberList"
              :key="item.member_id || item.really_name"
            >
              <div
                class="grid-content"
                @click="fnToMemberDetails(item.member_id)"
              >
                <el-image :src="$imgUrl + item.member_photo" fit="cover">
                  <div slot="error" class="image-slot">
                    <p
                      class="bg-title"
                      :style="
                        'background-color:' +
                        colors[Math.floor(Math.random() * colors.length)]
                      "
                    >
                      {{
                        item.really_name
                          .replace(/(^\s*)|(\s*)$/g, "")
                          .replace(/\（[^\）]*\）/g, "")
                          .replace(/\([^\)]*\)/g, "")[
                          item.really_name
                            .replace(/(^\s*)|(\s*)$/g, "")
                            .replace(/\（[^\）]*\）/g, "")
                            .replace(/\([^\)]*\)/g, "").length - 1
                        ]
                      }}
                    </p>
                  </div>
                </el-image>
                <h5>{{ item.really_name }}</h5>
                <span>{{ item.position }}</span>
              </div>
            </el-col>
          </el-row>
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="memberCurrentPage"
            :page-size="memberPageSize"
            :page-count="memberTotalPageNum"
            @current-change="handleMemberCurrentChange"
            v-if="totalPageNum > 0"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </el-main>
    <div v-else class="m-tabs">
      <el-tabs v-model="active" tab-position="top" @tab-click="tabClick">
        <el-tab-pane label="企業展示">
          <el-row class="company_list">
            <el-col
              :span="24"
              v-for="item in companyList"
              :key="item.company_id"
            >
              <div class="grid-content" @click="fnToCompany(item.company_id)">
                <el-image :src="$imgUrl + item.company_logo" fit="cover">
                  <div slot="error" class="image-slot">
                    <p class="bg-title" v-html="item.company_code[0]"></p>
                  </div>
                </el-image>
                <div class="company_title">
                  <h3 v-html="item.company_name"></h3>
                  <div class="company_info">
                    <div class="company_tel">
                      <em></em>
                      <span>{{ item.phone }}</span>
                    </div>
                    <div class="company_field">
                      <em></em>
                      <span>{{ item.industry_name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-pagination
            background
            small
            layout="prev, pager, next"
            :current-page="currentPage"
            :page-size="pageSize"
            :page-count="totalPageNum"
            @current-change="handleCurrentChange"
            v-if="totalPageNum > 0"
          >
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="會員名錄" class="member_list">
          <div class="file-type" v-if="areaList.length > 0">
            <h3>地区:</h3>
            <!-- <span :class="[{ active: ass_area_id == '' }, 'little_hand']" @click="changeArea(1, '')">全部</span> -->
            <span
              :class="[
                { active: ass_area_id == item.ass_area_id },
                'little_hand',
              ]"
              v-for="(item, index) in areaList"
              :key="index"
              @click="changeArea(1, item.ass_area_id)"
              >{{ item.area }}</span
            >
          </div>
          <div style="clear: both"></div>
          <el-row>
            <el-col :span="8" v-for="item in memberList" :key="item.member_id">
              <div
                class="grid-content"
                @click="fnToMemberDetails(item.member_id)"
              >
                <el-image :src="$imgUrl + item.member_photo" fit="cover">
                  <div slot="error" class="image-slot">
                    <p
                      class="bg-title"
                      :style="
                        'background-color:' +
                        colors[Math.floor(Math.random() * colors.length)]
                      "
                    >
                      {{
                        item.really_name
                          .replace(/(^\s*)|(\s*)$/g, "")
                          .replace(/\（[^\）]*\）/g, "")
                          .replace(/\([^\)]*\)/g, "")[
                          item.really_name
                            .replace(/(^\s*)|(\s*)$/g, "")
                            .replace(/\（[^\）]*\）/g, "")
                            .replace(/\([^\)]*\)/g, "").length - 1
                        ]
                      }}
                    </p>
                  </div>
                </el-image>
                <h5>{{ item.really_name }}</h5>
                <span>{{ item.position }}</span>
              </div>
            </el-col>
          </el-row>
          <el-pagination
            background
            small
            layout="prev, pager, next"
            :current-page="memberCurrentPage"
            :page-size="memberPageSize"
            :page-count="memberTotalPageNum"
            @current-change="handleMemberCurrentChange"
            v-if="totalPageNum > 0"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  traditionalized,
  simplized,
} from "../assets/js/simplifiedToTraditional.js";

export default {
  data() {
    return {
      active: this.$route.params.active ? this.$route.params.active + "" : "0",
      start: 0,
      limit: 12,
      companyList: [],
      pageSize: 6,
      totalPageNum: 0,
      currentPage: 0,
      memberStart: 0,
      memberLimit: 30,
      memberList: [],
      memberCurrentPage: 0,
      memberTotalPageNum: 0,
      memberPageSize: 18,
      colors: [
        "#528bce",
        "#43b2cd",
        "#527ba9",
        "#606cb8",
        "#4dbc70",
        "#13aa89",
      ],
      area: "",
      areaList: [],
      ass_area_id: "",
      ass_area: "",
      region: "",
      field: "",
      companyAreaList: [],
      companyFieldList: [],
      member_name: "",
      company_name: "",
    };
  },
  computed: {
    ...mapState(["infoRes", "isPc"]),
  },
  methods: {
    tabClick(e) {
      this.$router.push({
        path: `/company_member_list/${this.active}`,
      });
    },
    // 获取企业地區
    async getCompanyAreaList() {
      const { data: res } = await this.$http.get(
        `/api/v2/areaData/list?parent_id=234`
      );
      if (res.code !== "200") return this.$message.error(res.msg);
      this.companyAreaList = res.data;
    },
    // 获取企业分类
    async getCompanyIndustry() {
      const { data: res } = await this.$http.get(`/api/v2/company/industry`);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.companyFieldList = res.data;
    },
    clearSelect() {
      this.region = "";
      this.field = "";
    },
    async getEnterprisesList(th) {
      if (th == 1) {
        this.start = 0;
      }
      const { data: res } = await this.$http.get("/api/v2/company/pc/list", {
        params: {
          start: this.start,
          limit: this.limit,
          searchJson: {
            association_id: "SZTX",
            field: this.field,
            xt_districtID: this.region,
            company_name: traditionalized(this.company_name),
            // field行业分类
            // islisting:e,是否上市
            // area:this.value1,地区分类
          },
        },
      });
      // console.log(eval("(" + res.data + ")"));
      if (res.code !== "200") return this.$message.error(res.msg);
      this.companyList = eval("(" + res.data + ")").data;
      this.totalPageNum = eval("(" + res.data + ")").pagenum;
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.start = (val - 1) * this.limit;
      this.getEnterprisesList();
    },
    fnToCompany(company_id) {
      this.$router.push({
        path: `/company/${company_id}`,
      });
    },
    async getAssociationMemberList(th) {
      if (th == 1) {
        this.memberStart = 0;
      }
      const { data: res } = await this.$http.get(
        "/api/v2/association/pc/SZTX/persons",
        {
          params: {
            start: this.memberStart,
            limit: this.memberLimit,
            ass_area_id: this.ass_area_id,
            searchJson: {
              really_name: traditionalized(this.member_name),
            },
          },
        }
      );
      // console.log(eval("(" + res.data + ")"));
      if (res.code !== "200") return this.$message.error(res.msg);
      this.memberList = eval("(" + res.data + ")").data;
      // console.log(this.memberList);
      this.memberTotalPageNum = eval("(" + res.data + ")").pagenum;
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    handleMemberCurrentChange(val) {
      // console.log(`当前页=====: ${val}`);
      this.memberCurrentPage = val;
      this.memberStart = (val - 1) * this.memberLimit;
      this.getAssociationMemberList();
    },
    fnToMemberDetails(member_id) {
      if (!member_id) return false;
      this.$router.push({
        path: `/member_details/${member_id}`,
      });
    },
    async getSubArea() {
      const { data: res } = await this.$http.get(
        "/api/v2/association/SZTX/SubArea"
      );
      if (res.code !== "200") return this.$message.error(res.msg);
      this.areaList = res.data;
      this.ass_area = this.$route.query.ass_area
        ? this.$route.query.ass_area
        : "";
      if (this.ass_area=='') {
        this.ass_area_id = res.data[0].ass_area_id;
        this.getAssociationMemberList();
      }

      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    changeArea(type_id, ass_area_id, type_name) {
      this.ass_area_id = ass_area_id;
      this.memberCurrentPage = 0;
      this.getAssociationMemberList(1);
    },
  },
  watch: {
    $route(to, from) {
      this.active = to.params.active;
      this.area = to.query.area ? to.query.area : "";
      this.ass_area = to.query.ass_area ? to.query.ass_area : "";

      console.log(to);
    },
    companyAreaList(val) {
      if (!this.area) return false;
      let filterArr = val.filter((item) => {
        if (
          item.name.indexOf(this.area) != -1 ||
          item.name.indexOf(traditionalized(this.area)) != -1 ||
          item.name.indexOf(simplized(this.area)) != -1
        ) {
          return item;
        }
      });
      if (filterArr.length == 0) {
        this.region = "";

        this.getEnterprisesList();
      } else {
        this.region = filterArr[0].id;
      }
    },
    area(val) {
      if (this.companyAreaList.length == 0) return false;
      let filterArr = this.companyAreaList.filter((item) => {
        if (
          item.name.indexOf(val) != -1 ||
          item.name.indexOf(traditionalized(val)) != -1 ||
          item.name.indexOf(simplized(this.area)) != -1
        ) {
          return item;
        }
      });
      if (filterArr.length == 0) {
        this.region = "";
        this.getEnterprisesList();
      } else {
        this.region = filterArr[0].id;
      }
    },
    ass_area(val) {
      let filterArr = this.areaList.filter((item) => {
        if (item.area == val) {
          return item;
        }
      });
      console.log(filterArr);
      if (filterArr.length == 0) {
        this.changeArea(1, "");
      } else {
        this.ass_area_id = filterArr[0].ass_area_id;
        this.changeArea(1, this.ass_area_id);
      }
    },
    region(val) {
      this.currentPage = 0;
      this.getEnterprisesList(1);
    },
    field(val) {
      this.currentPage = 0;
      this.getEnterprisesList(1);
    },
  },
  created() {
    this.getCompanyAreaList();
    // this.getAssociationMemberList();
    this.getSubArea();
    this.getCompanyIndustry();
  },
  mounted() {
    this.active = this.$route.params.active;
    this.area = this.$route.query.area ? this.$route.query.area : "";
    if (!this.area) {
      this.getEnterprisesList();
    }
  },
};
</script>

<style lang="less" scoped>
.el-main {
  width: 1040px;
  margin-top: 30px;

  /deep/.el-form-item {
    margin-top: 20px;
  }

  /deep/.el-form-item__label {
    font-size: 18px;
    font-weight: bold;
  }

  /deep/.el-form-item__content {
    display: flex;
  }

  .el-select {
    margin-right: 20px;
    flex: 1;
  }
}

/deep/.el-tabs__header {
  width: 200px;
  background-color: rgb(244, 244, 244);
  margin-right: 30px !important;

  .el-tabs__nav-wrap::after {
    content: none;
  }

  .el-tabs__item {
    font-size: 18px;
    padding: 8px;
    height: auto;
    font-weight: normal;
    text-align: center !important;
    color: rgb(157, 156, 157);
  }

  .el-tabs__item.is-active {
    color: #ffffff;
    background: #4f4e95;
  }

  .el-tabs__item:hover {
    color: #4f4e95 !important;
  }

  .el-tabs__item.is-active {
    color: #ffffff !important;
  }

  .el-tabs__active-bar {
    background-color: #4f4e95;
  }
}

.el-tab-pane {
  .company_list {
    .el-col {
      min-height: auto;
    }

    .grid-content {
      cursor: pointer;
      padding: 10px;
      display: flex;
      align-items: center;
      border: 1px solid #f3f3f3;
      margin-bottom: 10px;
    }

    .el-image {
      width: 66px;
      height: 66px;
      margin-right: 15px;
    }

    .bg-title {
      width: 66px;
      height: 66px;
      line-height: 66px;
      background: #bbbbbb;
      border-radius: 10px;
      margin-right: 10px;
      font-size: 30px;
      color: #ffffff;
      text-align: center;
    }

    .company_title {
      flex: 1;

      h3 {
        font-size: 18px;
        color: #414141;
        line-height: 18px;
        margin-bottom: 14px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
        overflow: hidden;
      }

      .company_info {
        display: flex;
        align-items: center;
        justify-content: space-between;

        div {
          display: flex;
          align-items: center;
          // min-width: 100px;
        }

        span {
          font-size: 14px;
          line-height: 14px;
          color: #656565;
          max-width: 100px;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          word-break: break-all;
          overflow: hidden;
        }

        em {
          display: inline-block;
          width: 20px;
          height: 20px;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          vertical-align: middle;
          margin-right: 8px;
        }

        .company_tel em {
          background-image: url("../assets/images/enterprises-menu08.png");
        }

        .company_field em {
          background-image: url("../assets/images/enterprises-menu04.png");
        }
      }

      p {
        font-size: 16px;
        line-height: 24px;
        height: 48px;
        color: #999999;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
        overflow: hidden;
      }
    }
  }

  .el-pagination {
    text-align: center;
    margin-top: 60px;
  }

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4f4e95;
  }

  /deep/.el-pager li:not(.active):hover {
    color: #4f4e95 !important;
  }
}

/deep/.member_list {
  .grid-content {
    margin-bottom: 20px;
    text-align: center;

    .el-image {
      width: 90px !important;
      height: 120px !important;
      // border-radius: 80px;
    }

    h5 {
      padding: 0;
      font-size: 18px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }

    span {
      padding: 0 !important;
      line-height: 20px;
      font-size: 14px;
      color: #999999;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      overflow: hidden;
      height: 40px;
    }

    .bg-title {
      width: 100%;
      height: 120px;
      background: #bbbbbb;
      margin-right: 10px;
      font-size: 28px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
}

.el-col {
  min-height: 200px;
  cursor: pointer;
}

.m-tabs .company_list,
.m-tabs .member_list {
  padding: 0 20px;
}

.file-type {
  h3 {
    font-size: 20px;
    font-weight: bold;
    line-height: 50px;
    // display: inline;
    // float: left;
  }

  span {
    float: left;
    font-size: 16px;
    padding: 5px 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    border: 1px solid #eeeeee;
    color: #333;
  }

  .active {
    background: #4f4e95;
    color: #ffffff;
  }
}
</style>